import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bee23c2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "viewport filterSearch" }

import { onMounted, ref, watch } from 'vue'
import Header from '../components/Header.vue'
import VvicFilterSearch from '../components/VvicFilterSearch.vue'
import { lang, t } from '@/plugins/i18n'
import ProductList from '../components/productList.vue'
import StallItem from '../components/StallItem.vue'
import { MarketType, ModelValProps, PlatformTypeEnum, VVICmodelvalprops, VvicPlatformTypeEnum } from '../const'
import { useRequest } from '@/util/useLoading'
import { searchProducts } from '@/apis/search'
import { selectLastCategoryTree, selectLastCategoryTreeDetail, supplierShopPageList } from '@/apis/goods'
import { useStore } from 'vuex'
import GoodsItem from '@/components/common/GoodsItem.vue'
import VvicItem from '../components/VvicItem.vue'
import { Site } from '@/common/const'
import { useRtfix, useSite2Station } from '@/store'
import router from '@/router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const advantage = [t('精品女装'), t('一手货源'), t('真实档口')]
// 搜索参数
const searchParams = ref<VVICmodelvalprops>({})
const productResult = ref({})

const [loading, searchProductsApi] = useRequest(searchProducts)
const [loading1, supplierShopPageListApi] = useRequest(supplierShopPageList)
const [loading2, selectLastCategoryTreeDetailApi] = useRequest(selectLastCategoryTreeDetail)

const changeSearch = (val: VVICmodelvalprops) => {
  searchParams.value = { ...val, pageNum: 1, pageSize: val.navTab === MarketType.ZSP ? 50 : 30 }
}
// platformType平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园
watch(() => searchParams.value, async (val) => {
  if (val.navTab === MarketType.ZSP) {
    // 商品榜
    if (val.areaCodes === VvicPlatformTypeEnum['VC-SPB']) {
      // if (val?.cateCode) {
      const res = await selectLastCategoryTreeDetailApi({ ...val, parentCateCode: val.cateCode })
      productResult.value = res.data
      // } else {
      //   const records = filterClassify.value.filter(i => i.cateCode).reduce((pre, cur) => {
      //     return pre.concat(cur.subCategoryList)
      //   }, [])

      //   productResult.value = {
      //     records
      //   }
      // }
    } else {
      productResult.value = {
        records: [],
        total: 0
      }
      const params = { ...val, areaCodes: val.areaCodes, thirdProductCateCode: val.cateCode2 || val.cateCode1, platformType: PlatformTypeEnum.VC }
      if (params.sortType === 'update_time') {
        params.descendOrder = true
      }
      const res = await searchProductsApi(params)
      console.log(res, 'res')

      productResult.value = res?.data
    }
  }
  if (val.navTab === MarketType.ZDK) {
    const res = await supplierShopPageListApi({ ...val, platformType: PlatformTypeEnum.VC, strongSupplier: val.strongSupplier ? 1 : null, status: 1 })
    productResult.value = res?.data
  }
}, {
  deep: true
})

const filterClassify = ref<any[]>([])
const stationCode = useSite2Station()

const gotoProductList = (item: any) => {
  const label = {
    [Site.JA]: item.cateNameJp,
    [Site.KO]: item!.cateNameKr,
    [Site.EN]: item!.cateNameEn
  }[stationCode] as string
  const url = router.resolve(useRtfix('market_vvic_list', { query: { cateCode: item?.cateCode, cateName: label } }))
  window.open(url.href, '_blank')
}
onMounted(async () => {
  const res = await selectLastCategoryTree({})
  filterClassify.value = [
    {
      label: t('全部'),
      value: undefined
    },
    ...res.data.map((item: any) => {
      const label = {
        [Site.JA]: item.cateNameJp,
        [Site.KO]: item!.cateNameKo,
        [Site.EN]: item!.cateNameEn
      }[stationCode] as string
      return {
        ...item,
        label: label,
        value: item.cateCode
      }
    })
  ]
})


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      advantage: advantage,
      mfcolor: "#EC3A66",
      bgColor: "rgba(236, 58, 102, 0.10)",
      title: _unref(t)('搜款网聚焦女装潮流，针对年轻都市丽人，提供性价比高、款式前沿的优质服装配饰。'),
      logo: "https://static-s.theckb.com/BusinessMarket/Client/market/market_vvic_logo.png"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(VvicFilterSearch, {
        filterClassify: filterClassify.value,
        onChange: changeSearch
      }, null, 8, ["filterClassify"]),
      (searchParams.value.navTab === _unref(MarketType).ZSP)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (searchParams.value.areaCodes === _unref(VvicPlatformTypeEnum)['VC-SPB'])
              ? (_openBlock(), _createBlock(ProductList, {
                  key: "VC-SPB",
                  pageNum: searchParams.value.pageNum,
                  "onUpdate:pageNum": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.pageNum) = $event)),
                  pageSize: searchParams.value.pageSize,
                  "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.pageSize) = $event)),
                  data: productResult.value
                }, {
                  default: _withCtx(({ item }) => [
                    _createVNode(VvicItem, {
                      onClick: ($event: any) => (gotoProductList(item)),
                      vvicItem: item
                    }, null, 8, ["onClick", "vvicItem"])
                  ]),
                  _: 1
                }, 8, ["pageNum", "pageSize", "data"]))
              : (_openBlock(), _createBlock(ProductList, {
                  key: "GoodsItem",
                  pageNum: searchParams.value.pageNum,
                  "onUpdate:pageNum": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.pageNum) = $event)),
                  pageSize: searchParams.value.pageSize,
                  "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((searchParams.value.pageSize) = $event)),
                  data: productResult.value
                }, {
                  default: _withCtx(({ item }) => [
                    _createVNode(GoodsItem, {
                      key: item.productCode,
                      style: {"width":"219.5px"},
                      item: item,
                      showChannel: 1
                    }, null, 8, ["item"])
                  ]),
                  _: 1
                }, 8, ["pageNum", "pageSize", "data"]))
          ], 64))
        : _createCommentVNode("", true),
      (searchParams.value.navTab === _unref(MarketType).ZDK)
        ? (_openBlock(), _createBlock(ProductList, {
            key: "stall",
            pageNum: searchParams.value.pageNum,
            "onUpdate:pageNum": _cache[4] || (_cache[4] = ($event: any) => ((searchParams.value.pageNum) = $event)),
            pageSize: searchParams.value.pageSize,
            "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((searchParams.value.pageSize) = $event)),
            data: productResult.value
          }, {
            default: _withCtx(({ item }) => [
              (item.supplierShopCode)
                ? (_openBlock(), _createBlock(StallItem, {
                    key: item.supplierShopCode,
                    stall: item
                  }, null, 8, ["stall"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["pageNum", "pageSize", "data"]))
        : _createCommentVNode("", true)
    ])
  ], 512)), [
    [_directive_loading, _unref(loading) || _unref(loading1) || _unref(loading2)]
  ])
}
}

})